import { render, staticRenderFns } from "./SectionWrapper.vue?vue&type=template&id=5e5b9978&scoped=true"
import script from "./SectionWrapper.vue?vue&type=script&lang=js"
export * from "./SectionWrapper.vue?vue&type=script&lang=js"
import style0 from "./SectionWrapper.vue?vue&type=style&index=0&id=5e5b9978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5b9978",
  null
  
)

export default component.exports